import Grid from '@material-ui/core/Grid'
import React, { ComponentProps, PropsWithChildren } from 'react'

export type QuickLinksWrapperProps =  Omit<ComponentProps<typeof Grid>, 'direction'> & {
  //
}

export const QuickLinksWrapper: React.FC<PropsWithChildren<QuickLinksWrapperProps>> = ({  container = true, alignContent = 'center', justifyContent = 'space-between', children, ...props }) => {
  return (
    <Grid container={container} direction="row" alignContent={alignContent} justifyContent={justifyContent} { ...props }>
      { children }
    </Grid>
  )
}
